import { useRef } from 'react';
import { Button, DialogActions, Dialog, DialogContent, DialogTitle, Paper, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DialogUI = (props) => {
  const theme = useTheme();
  const ui = theme.palette.ui;
  const { open, headerContent, children, onClose, headerColor, closeBtn, contentStyle, actionsContent } = props;

  return (
    <Dialog open={open} onClose={onClose} {...props}>
      <DialogTitle sx={{ background: ui.dialogHeader }}>
        {headerContent && (
          <h2 className={`${headerColor ? `text-${headerColor}` : 'text-white'} py-1 px-3 rounded`}>{headerContent}</h2>
        )}
      </DialogTitle>
      <DialogContent sx={contentStyle}>{children}</DialogContent>

      <DialogActions sx={{ display: 'flex', gap: 1 }}>
        <Box>{actionsContent}</Box>
        <Box>{closeBtn && <Button onClick={onClose}>Bezárás</Button>}</Box>
      </DialogActions>
    </Dialog>
  );
};

export default DialogUI;
